// Commas belong to institution/credential names; only line breaks delimit entries.
export const profileEntryLines = value => (Array.isArray(value) ? value : [value])
  .flatMap(item => typeof item === 'string' ? item.split(/\r?\n/) : [])
  .map(item => item.trim()).filter(Boolean);
